import React, { FC } from 'react'
import OnboardingStepTemplate from '../OnboardingStepTemplate'
import { Box, Text } from '@chakra-ui/react'
import { styled } from 'styled-components'
import { useReduxSelector } from '../../../../redux/baseStore'
import { selectSessionSessions } from '../../../../redux/sessionSlice'
import { useUserContext } from '../../../../contexts/UserContext'
import { GLOBAL_WINDOW_MESSAGE_ENUM, sendGlobalWindowMessage } from '../../../../utils/utils'
import { hasValidSessions } from '../../../../utils/sessionUtils'
import { useLocalStorageBoolean } from '../../../../utils/genericHooks'
import { WEBAPP_LOCAL_STORAGE_KEYS } from '../../../../models/browserStorage.types'

const Container = styled(Box)`
  .large-text,
  .large-text * {
    font-size: 28px;
    font-weight: 500;
    line-height: 40px;
    color: #000;
    letter-spacing: -1px;

    @media (max-width: 1200px) {
      /* Screens narrower than 1200px */
      font-size: 24px;
      line-height: 36px;
    }
  }
`

interface Props {
  onNext: () => void
}
const OnboardingNoSessionsV3Dialog: FC<Props> = (props) => {
  const { onNext } = props
  const sessions = useReduxSelector(selectSessionSessions)
  const { captureAnalytics } = useUserContext()
  const [hasCompletedOnboardingInThePast] = useLocalStorageBoolean(
    WEBAPP_LOCAL_STORAGE_KEYS.HasCompletedOnboardingInThePast,
    false,
  )
  const revisitedAnalyticsPostfix = hasCompletedOnboardingInThePast ? ':revisted' : ''

  return (
    <OnboardingStepTemplate
      phaseNum={4}
      numPhases={6}
      bodyContent={
        <>
          <Container>
            {sessions && sessions.length > 0 ? (
              <>
                <Text className="large-text">
                  We even grouped the ones you&apos;ll need soon into{' '}
                  <span style={{ textDecoration: 'underline' }}>Sessions</span>.
                </Text>
                <Text mt="18px" fontWeight="400" fontSize="16px" color="#585858">
                  Think of Sessions like brain-friendly bookmarks - they keep your tabs organized
                  exactly how you were using them.
                </Text>
              </>
            ) : (
              <Text className="large-text">
                Soon, we&apos;ll start to group related ones together into{' '}
                <span style={{ textDecoration: 'underline' }}>Sessions</span> to keep your tabs
                organized exactly how you were using them.
              </Text>
            )}
          </Container>
        </>
      }
      buttonText={`Okay`}
      onButtonClick={() => {
        const validSessions = hasValidSessions(sessions)
        if (!validSessions) {
          captureAnalytics(`onboarding_tutorial:skipped_sessions${revisitedAnalyticsPostfix}`, {
            numSmartSessions: sessions?.length ?? 0,
          })
          sendGlobalWindowMessage(GLOBAL_WINDOW_MESSAGE_ENUM.SKIP_SESSIONS_ONBOARDING_STEPS)
        } else {
          onNext()
        }
      }}
      delayButtonActivation={false}
    />
  )
}
export default OnboardingNoSessionsV3Dialog
